<template>
  <div>
    <hot-table
      :settings="settings"
      ref="tablaCalificaciones"
    ></hot-table>
  </div>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import { api } from '~/config'
  import { HotTable } from '@handsontable/vue'
  import Handsontable from 'handsontable'
  import Form from '~/mixins/form'

  export default {
    mixins: [Form],

    components: {
      HotTable
    },

    data: () => ( {

      observacion: [],

      settings: {
        data: [
          [],
        ],

        colHeaders: [ 'Nombre de Asignatura', 'Clave de Asignatura', 'Ciclo Escolar', 'Calificación', 'Observación' ],

        comments: true,
        rowHeaders: true,
        preventOverflow: 'horizontal',
        manualColumnResize: true,
        renderAllRows: true,

        contextMenu: {
          items: {
            'copy': {
              name: 'Copiar'
            },
            'cut': {
              name: 'Cortar'
            },
            'separator': Handsontable.plugins.ContextMenu.SEPARATOR,
            'clear_custom': {
              name: 'Borrar todas las celdas',
              callback: function () {
                this.clear();
              }
            },
          }
        },

        stretchH: 'all',

        afterChange: function ( change, source ) {
          let id = this.rootElement.__vue__.$route.params.id

          if ( source === "loadData" ) {
            if ( localStorage[ 'dataCalificaciones[' + id + ']' ] ) {
              let dataCalificaciones = JSON.parse( localStorage[ 'dataCalificaciones[' + id + ']' ] )
              this.loadData( dataCalificaciones )
              this.render()
            }

          } else {
            localStorage[ 'dataCalificaciones[' + id + ']' ] = JSON.stringify( this.getData() )
          }
        },

        columns: [ {
            readOnly: true
          },
          {
            readOnly: true
          },
          {
            validator: /^((19|2[0-1])\d{2}-[1-9]\d?|)$/,
            allowInvalid: true
          },
          {
            type: 'dropdown',
            source: [ '5.00', '6.00', '7.00', '8.00', '9.00', '10']
          },
          {
            type: 'dropdown',
          },
        ]
      }
    } ),

    computed: {
      ...mapGetters({
        live_mode: "auth/live_mode",
      })
    },

    watch: {
      live_mode(val) {
        if (val !== undefined) {
          this.$router.push({ name: 'lotes-certificados' })
        }
      }
    },

    mounted() {
      window.addEventListener( 'resize', this.updateTableSize )

      let id = this.$route.params.id
      let dataCertificados = JSON.parse( localStorage[ 'dataCertificados' ] )
      let dataCertificado = dataCertificados[ id - 1]
      let entidad_federativa = dataCertificado[1]
      let tipo_rvoe = dataCertificado[3]

      console.log('entidad_federativa=', entidad_federativa)
      console.log('tipo_rvoe=', tipo_rvoe)

      if ( entidad_federativa === 'BAJA CALIFORNIA' && tipo_rvoe === 'Estatal' ) {
        
        this.$refs.tablaCalificaciones.hotInstance.updateSettings( {
          colHeaders: [ 'Nombre de Asignatura', 'Clave de Asignatura', 'Ciclo Escolar', 'Periodo', 'Calificación', 'Observación' ],
          columns: [ {
            readOnly: true
          },
          {
            readOnly: true
          },
          {
            validator: /^((19|2[0-1])\d{2}-(19|2[0-1])\d{2}-[1-9]\d?)$/,
            allowInvalid: true
          },
          {
            validator: /^[1-9][0-9]?$/,
            allowInvalid: true
          },
          {
            type: 'dropdown',
            source: [ '5', '6', '7', '8', '9', '10']
          },
          {
            type: 'dropdown',
          },
        ]
        })

        this.getCatalogoBcObservacion()
      } else {
        this.getCatalogoObservacion()
      }

      this.updateTableSize()
    },

    methods: {
      updateTableSize() {
        this.$nextTick(() => {
          if(this.$refs.tablaCalificaciones && typeof this.$refs.tablaCalificaciones.hotInstance !== 'undefined') {
            this.$refs.tablaCalificaciones.hotInstance.updateSettings( {
              height: window.innerHeight - 48
            } )
          }
        });
      },

      getCatalogoObservacion() {
        axios
          .get(api.path('catalogos.observacion'))
          .then(res => {
            let observaciones = []

            res.data.forEach(function(observacion) {
              if(observacion.descripcion_corta) {
                observaciones.push(observacion.descripcion_corta + ' (' + observacion.descripcion + ')')
              } else {
                observaciones.push(observacion.descripcion)
              }
            });

            this.$refs.tablaCalificaciones.hotInstance.updateSettings( {
              cells: function ( row, col ) {
                const cellProp = {}

                if ( col === 4 ) {
                  cellProp.type = 'dropdown';
                  cellProp.source = observaciones
                }

                return cellProp
              },
            })
          })
          .catch(err => {
            this.handleErrors(err.response.data.errors)
          })
          .then(() => {})
      },

      getCatalogoBcObservacion() {
        axios
          .get(api.path('catalogos.bc_observacion'))
          .then(res => {
            let observaciones = []

            res.data.forEach(function(observacion) {
              observaciones.push(observacion.uuid + '. (' + observacion.nombre + ')')
            });

            this.$refs.tablaCalificaciones.hotInstance.updateSettings( {
              cells: function ( row, col ) {
                const cellProp = {}

                if ( col === 5 ) {
                  cellProp.type = 'dropdown';
                  cellProp.source = observaciones
                }

                return cellProp
              },
            })
          })
          .catch(err => {
            this.handleErrors(err.response.data.errors)
          })
          .then(() => {})
      },
    }
  }
</script>

<style src="~/../node_modules/handsontable/dist/handsontable.full.css"></style>
